// extracted by mini-css-extract-plugin
module.exports = {"up":"Rank_up__1dF6b","down":"Rank_down__pmMWW","allrank":"Rank_allrank__Jqru0"};